import React, { useState } from 'react';
import { Flex, Box, ShowInMediumDown, ShowInMediumUp } from './layout/Grid';
import Button from './buttons';
import Icon from './Icon';

type Props = React.PropsWithChildren<{
  main: React.ReactNode;
}>;

const Collapsable = (props: Props) => {
  const [contentShown, setContentShown] = useState(true);

  const togglCollapse = () => {
    setContentShown((contentShown) => {
      return !contentShown;
    });
  };

  return (
    <React.Fragment>
      <Flex justifyContent="space-between" alignItems="center">
        <Box onClick={togglCollapse}>{props.main}</Box>
        <Box as={ShowInMediumDown}>
          <Button appearance="link" onClick={togglCollapse}>
            <Icon
              color="black"
              name={contentShown ? 'ygb-icon-arrow-down' : 'ygb-icon-arrow-up'}
            />
          </Button>
        </Box>
      </Flex>
      <ShowInMediumDown>
        {!contentShown ? props.children : null}
      </ShowInMediumDown>
      <ShowInMediumUp>{contentShown ? props.children : null}</ShowInMediumUp>
    </React.Fragment>
  );
};

export default Collapsable;
